import React from 'react';
import { ChatTableProps } from '@/types/chat';

export const ChatTable = ({ tableConfig }: ChatTableProps) => {
  if (!tableConfig) {
    return <div>No table data available.</div>;
  }
  const columns = tableConfig.columns;
  const rows = tableConfig.rows;

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="overflow-x-auto overflow-y-auto max-h-80 relative">
        <table className="border-collapse w-full min-w-full">
          <thead className="bg-slate-50 sticky top-0 z-10">
            <tr>
              {columns.map((column, i) => (
                <th
                  key={i}
                  className="px-4 py-3 text-left text-xs font-semibold text-slate-700 whitespace-nowrap border-r border-slate-200 last:border-r-0 bg-slate-50 min-w-[120px]">
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {rows.map((row, i) => (
              <tr
                key={i}
                className="border-b border-slate-200 hover:bg-slate-50 transition-colors">
                {columns.map((column, j) => (
                  <td
                    key={j}
                    className="px-4 py-3 text-sm text-slate-600 whitespace-nowrap border-r border-slate-100 last:border-r-0 min-w-[120px]">
                    {row[column.field]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
